var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSortLightbulb = function SvgSortLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      strokeLinejoin: "round"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 6v15M22 19l-3 3M19 22l-3-3M7.67 18.327v-1.15c-.024-.703-.104-1.403-.929-2.348-.617-.707-1.319-2.174-1.342-3.408.061-2.313 1.448-4.108 3.766-4.034 2.03.099 3.664 1.745 3.616 3.927-.049 1.61-.886 2.84-1.39 3.572-.816 1.188-.962 1.72-.995 2.471l-.04 1.009zM8.6 21.7h1m-2-.7h3M5.7 6.5 5.3 6M9.1 5.3v-.7M12.6 6.3l.4-.5"
  }))));
};
export default SvgSortLightbulb;